"use client";

import { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  label: "§ 05.1 — SERVICE REACH",
  value: 450,
  suffix: "",
  unit: "INDIVIDUALS · SUPPORTED ANNUALLY",
  note: "Providing personalized care plans across Connecticut communities.",
  color: "cerulean"
}, {
  label: "§ 05.2 — DDS COMPLIANCE",
  value: 100,
  suffix: "%",
  unit: "CERTIFICATION · QUALITY RATING",
  note: "Maintaining rigorous standards for state-qualified service delivery.",
  color: "slate"
}, {
  label: "§ 05.3 — CARE HOURS",
  value: 85000,
  suffix: "",
  unit: "HOURS · DIRECT SUPPORT PROVIDED",
  note: "Dedicated assistance delivered by our professional care team.",
  color: "cerulean"
}, {
  label: "§ 05.4 — COMMUNITY",
  value: 12,
  suffix: "",
  unit: "REGIONS · SERVED STATEWIDE",
  note: "Expanding our footprint to ensure accessible care for every family.",
  color: "slate"
}];
const tickerItems = ["DDS-QUALIFIED", "CT-CARE", "SUPPORT-SERVICES", "COMMUNITY-FIRST", "PERSON-CENTERED", "WELLNESS-GOALS", "PROFESSIONAL-CARE", "DDS-COMPLIANT", "CT-WELLNESS", "SERVICE-EXCELLENCE", "FAMILY-SUPPORT", "CARE-NETWORK"];
function useCountUp(target: number, start: boolean, duration = 1200) {
  const [value, setValue] = useState(0);
  const startedRef = useRef(false);
  useEffect(() => {
    if (!start || startedRef.current) return;
    startedRef.current = true;
    const startTime = performance.now();
    const ease = (t: number) => {
      return 1 - Math.pow(1 - t, 3);
    };
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const t = Math.min(elapsed / duration, 1);
      setValue(Math.round(target * ease(t)));
      if (t < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [start, target, duration]);
  return value;
}
function StatBlock({
  stat,
  index,
  triggered
}: {
  stat: (typeof stats)[number];
  index: number;
  triggered: boolean;
}) {
  const animated = useCountUp(stat.value, triggered);
  const colorStyle = stat.color === "cerulean" ? {
    color: "hsl(195 100% 40%)"
  } : {
    color: "hsl(200 33% 34%)"
  };
  return <div data-index={index} className="relative flex flex-col gap-4 px-0 py-8 md:py-0 md:px-8 first:md:pl-0 last:md:pr-0">
      <div className="font-mono uppercase" style={{
      fontSize: "0.75rem",
      letterSpacing: "0.2em",
      fontWeight: 500,
      color: "hsl(215 15% 75%)"
    }}>
        <span style={{
        color: "hsl(195 100% 40%)"
      }}>
          {stat.label.split("—")[0].trim()}
        </span>
        <span style={{
        color: "hsl(215 15% 75%)"
      }}>
          {" "}— {stat.label.split("—")[1].trim()}
        </span>
      </div>

      <div className="font-serif" style={{
      fontSize: "clamp(3.5rem, 7.5vw, 7.5rem)",
      fontWeight: 400,
      letterSpacing: "-0.02em",
      lineHeight: 0.95,
      ...colorStyle
    }}>
        {animated.toLocaleString()}{stat.suffix}
      </div>

      <div className="font-mono uppercase" style={{
      fontSize: "0.75rem",
      letterSpacing: "0.04em",
      fontWeight: 500,
      color: "hsl(210 20% 98%)"
    }}>
        {stat.unit}
      </div>

      <p className="font-default" style={{
      fontSize: "1rem",
      lineHeight: 1.6,
      color: "hsl(215 15% 75%)",
      maxWidth: "28ch"
    }}>
        {stat.note}
      </p>
    </div>;
}
export default function Impact() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15,
    once: true
  });
  return;
}